import {
  Container,
  Project,
  Image,
  ImageWrapper,
  InfoWrapper,
  Title,
  Stack,
  Item,
  Links,
  Details,
} from './styles';
import Section from '../../shared/Section';
import SectionHeader from '../../shared/SectionHeader';
import MarginWrapper from '../../shared/MarginWrapper';
import Card from '../../shared/Card';
import LinkIconButton from '../../shared/LinkIconButton';
import projects from '../../data/projects';
import { FiGithub, FiExternalLink } from 'react-icons/fi';

const Projects = () => {
  return (
    <Section id="projects">
      <SectionHeader>Projects</SectionHeader>
      <Container>
        {projects.map((p, i) => (
          <Card key={p.id} zeroPadding bottomMargin={i !== projects.length - 1}>
            <Project>
              <ImageWrapper>
                <Image src={p.desktopImage} />
                <Image src={p.mobileImage} lessShadow />
              </ImageWrapper>
              <InfoWrapper>
                <Title bigger>{p.name}</Title>
                <Details>
                  <MarginWrapper lesser>
                    <p>{p.description}</p>
                  </MarginWrapper>
                  <Stack>
                    {p.stack.map((s, i) => (
                      <Item key={i}>{s}</Item>
                    ))}
                  </Stack>
                  <Links>
                    <LinkIconButton href={p.codeUrl} target="_blank" smaller>
                      <FiGithub />
                    </LinkIconButton>
                    <LinkIconButton href={p.liveUrl} target="_blank" smaller>
                      <FiExternalLink />
                    </LinkIconButton>
                  </Links>
                </Details>
              </InfoWrapper>
            </Project>
          </Card>
        ))}
      </Container>
    </Section>
  );
};

export default Projects;
